import { inject, Injectable, InjectionToken } from '@angular/core';
import { AuthProvider } from './auth-provider.interface';
import { MsAuthProvider } from './ms-auth.provider';
import { OasAuthProvider } from './oas-auth.provider';
import { PrincipalAuthProvider } from './principal-auth.provider';
import OktaAuth from '@okta/okta-auth-js';

export const OKTA_OAS_AUTH = new InjectionToken<OktaAuth>('OKTA_OAS_AUTH');
export const OKTA_MS_AUTH = new InjectionToken<OktaAuth>('OKTA_MS_AUTH');

@Injectable({
  providedIn: 'root',
})
export class AuthFactoryService {
  private readonly principalAuth = inject(PrincipalAuthProvider);
  private readonly oasAuth = inject(OasAuthProvider);
  private readonly msAuth = inject(MsAuthProvider);

  getAllProviders(): AuthProvider[] {
    return [this.principalAuth, this.oasAuth, this.msAuth];
  }

  getProvider(key: string): AuthProvider {
    switch (key) {
      case 'principal':
        return this.principalAuth;
      case 'oas':
        return this.oasAuth;
      case 'ms':
        return this.msAuth;
      default:
        throw new Error(`Unknown provider: ${key}`);
    }
  }

  getProviderByCallbackState(callbackState: string): AuthProvider | null {
    // 'defaultRedirect' | 'principalRedirect' | 'oasRedirect' | 'msRedirect'
    switch (callbackState) {
      case 'defaultRedirect':
      case 'principalRedirect':
        return this.principalAuth;
      case 'oasRedirect':
        return this.oasAuth;
      case 'msRedirect':
        return this.msAuth;
      default:
        console.error(`Unknown callback state : ${callbackState}`);
        return null;
    }
  }
}
